<template>
    <header class="bg-white sticky-top shadow-sm px-2 px-md-3 d-flex flex-column justify-content-center" style="min-height: 56px; z-index: 1030;">
        <div class="d-flex align-items-center gap-2 min-w-0 py-2">
            <!-- Botón Menú - Optimizado para móvil -->
            <button
                class="btn btn-light d-lg-none me-1 d-flex align-items-center justify-content-center"
                style="width: 44px; height: 44px;"
                @click="$emit('open-sidebar')"
                aria-label="Abrir menú"
            >
                <i class="bi bi-list fs-4" />
            </button>

            <span class="titulo-pagina fw-semibold flex-grow-1">
                <div class="d-flex flex-column">
                    <span class="d-inline d-lg-none text-truncate fw-bold">{{ mobileTitle || title }}</span>
                    <span class="d-none d-lg-inline">{{ title }}</span>

                    <!-- Breadcrumbs - Móvil y Tablet (Debajo del título) -->
                    <nav aria-label="breadcrumb" class="d-lg-none min-w-0">
                        <ol class="breadcrumb mb-0 flex-nowrap" style="font-size: 0.73rem;">
                            <li class="breadcrumb-item" :class="{ active: crumbs.length === 0 }">
                                <RouterLink v-if="crumbs.length > 0" to="/">Inicio</RouterLink>
                                <span v-else>Inicio</span>
                            </li>
                            <li
                                v-for="(crumb, i) in crumbs.slice(-1)"
                                :key="i"
                                class="breadcrumb-item active text-truncate"
                            >
                                <span>{{ crumb.label }}</span>
                            </li>
                        </ol>
                    </nav>
                </div>
            </span>

            <div id="page-header-actions" class="d-flex align-items-center gap-2" />

            <!-- Botón Buscar - Optimizado para móvil -->
            <RouterLink
                :to="{ name: 'search' }"
                class="btn btn-outline-secondary d-lg-none d-flex align-items-center justify-content-center"
                style="width: 32px; height: 32px;"
                aria-label="Buscar"
            >
                <i class="bi bi-search" style="font-size: 0.875rem;" />
            </RouterLink>
        </div>

        <!-- Breadcrumbs - Escritorio (Superior a 992px) -->
        <nav aria-label="breadcrumb" class="d-none d-lg-block mt-n1 pb-1">
            <ol class="breadcrumb mb-0" style="font-size: 0.75rem;">
                <li class="breadcrumb-item" :class="{ active: crumbs.length === 0 }">
                    <RouterLink v-if="crumbs.length > 0" to="/">Inicio</RouterLink>
                    <span v-else>Inicio</span>
                </li>
                <li
                    v-for="(crumb, i) in crumbs"
                    :key="i"
                    class="breadcrumb-item"
                    :class="{ active: i === crumbs.length - 1 }"
                >
                    <RouterLink v-if="crumb.to" :to="crumb.to">{{ crumb.label }}</RouterLink>
                    <span v-else>{{ crumb.label }}</span>
                </li>
            </ol>
        </nav>
    </header>
</template>

<script setup lang="ts">
import { usePageHeader } from '@/composables/usePageHeader'
import { useBreadcrumbs } from '@/composables/useBreadcrumbs'

defineEmits<{
    (e: 'open-sidebar'): void
}>()

const { title, mobileTitle } = usePageHeader()
const { crumbs } = useBreadcrumbs()
</script>

<style scoped>
.titulo-pagina {
    min-width: 0;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}

#page-header-actions {
    flex-shrink: 0;
}

@media (max-width: 575.98px) {
    #page-header-actions {
        gap: 0.25rem !important;
    }

    #page-header-actions :deep(.btn) {
        padding-inline: 0.5rem;
    }
}

/* Ajustes finos para Bootstrap */
.mt-n1 {
    margin-top: -0.25rem !important;
}
</style>
